export type SelectedTechnicians = {
    id?: string | number;
    assignmentId?: string | number;

    userId: string;
    userName: string;
    laborCategory: string;
    fleetNumber: string;
    fleetName: string;
    perDiem: string;
};

export type Work = {
    id: string | number;
    projectId: string | number;
    projectName: string;
    proposalId?: string | number;
    proposalNumber?: string;
    serviceId?: string | number;
    serviceName?: string;
    category: string;
    subCategory: string;
    location: string;
    coords: string;
    startTime: string;
    endTime: string;
    allDay: "no" | "yes" ;
    supervisorName: string;
    supervisorId: string;
    fieldSupervisorName: string;
    fieldSupervisorEmail: string;
    siteContactId: string | number;
    siteContactName: string;
    siteContactMobile: string;
    cadRequired: "no" | "yes" ;
    reportRequired: "no" | "yes" ;
    waiveJSA: "no" | "yes" ;
    description: string;
    creatorName: string;
    createdAt: string;
    updaterName: string;
    updatedAt: string;
    void: "no" | "yes" ;
    voidReason: string;
    attachmentFolderId: string;
    folderId: string;
    
    leadId: string;

    workFiles: unknown[];
    technicians: unknown[];

    [key: string]: any;
};

export type WorkListResponse = {
    works: Work[];
    total: number;
    page?: number;
    limit?: number;
};

export type WorkProject = {
    projectId?: string | number;
    projectName?: string;
    projectNumber?: string;
    organizationId?: number;
    proposalId?: string | number;
    organizationName?: string;
    clientProjectNumber?: string;
    location?: string;
    coords?: string;
    clientName?: string;
    projectManagerId?: string;
    description?: string;
    [key: string]: any;
};

export type WorkUser = {
    email: string;
    userName: string;
    role?: string;
    assignments?: string;
    quitDate?: string;
    profileUrl?: string;
    [key: string]: any;
};

export type SiteContact = {
    contactId: string;
    contactName: string;
    mobile?: string;
    [key: string]: any;
};

export type WorkKeyword = "Add" | "Edit" | "Copy";


export type TechOption = {
    id?: string | number;
    assignmentId?: string | number;

    value: string;
    label: string;

    userId: string;
    userName: string;
    laborCategory: string;
    fleetNumber: string;
    perDiem: string;
    disabled?: boolean;
};

export const defaultWork: Work = {
    id: "",
    workId: "",
    projectId: "",
    projectName: "",
    serviceId: "",
    serviceName: "",
    category: "",
    subCategory: "",
    location: "",
    coords: "",
    startTime: "",
    endTime: "",
    allDay: "yes",
    supervisorName: "",
    supervisorId: "",
    fieldSupervisorName: "",
    fieldSupervisorEmail: "",
    siteContactId: "",
    siteContactName: "",
    siteContactMobile: "",
    cadRequired: "no",
    reportRequired: "no",
    waiveJSA: "no",
    description: "",
    creatorName: "",
    createdAt: "",
    updaterName: "",
    updatedAt: "",
    void: "no",
    voidReason: "",
    attachmentFolderId: "",
    folderId: "",
    workFiles: [],
    technicians: [],
    leadId: "",
};

export const laborCategorys = [
    "General Labor",
    "SoCal Labor NPLA",
    "NorCal Labor NPLA",
    "Locating",
    "USA Mark",
    "StandBy",
    "Foreman",
    "Surface Removal",
    "Surface Restoration",
    "Traffic Control",
    "GPR & Concrete Scaning & Coring",
    "GPR & Concrete Scanning",
    "GPR & Concrete Coring",
    "Surveying",
    "Mapping",
    "Reports",
    "CCTV",
    "Hydro Flushing",
    "QA/QC",
    "Training",
    "Travel",
    "Pothole Operator - Local 3 NPLA",
    "Pothole Operator - Local 12 NPLA",
    "Pothole Labor - Nor Cal",
    "Pothole Labor Helper - Nor Cal",
    "Pothole Labor Helper - So Cal",
    "Pothole Labor - So Cal",
    "Pothole Operator - Local 3",
    "Pothole Operator - Local 12",
    "Labor Locator - Nor Cal",
    "Labor Locator - So Cal",
    "1245 Locator",
    "Saw Cutting",
    "Specialty Vaccum",
];

export const laborShopsCategorys = [
    "Hayward Shop",
    "Fremont Shop",
    "Gilroy Shop",
    "Fresno Shop",
    "Ontario Shop",
    "Sacramento Shop",
    "Training",
];
